import Consumo from "./Consumo";
export default Consumo;